import { BankruptcyStatusBadge } from '@/modules/tools/bankruptcy/components/BankruptcyStatusBadge'
import { BANKRUPTCY_STATUSES } from '@/modules/tools/bankruptcy/constants'
import type { Filing } from '@/modules/tools/bankruptcy/stores/types'

export const CaseStatusCell = ({ filing }: { filing: Filing }) => {
  const explanation = blockedDraftExplanation(filing)

  return (
    <div className="space-y-0.5">
      <BankruptcyStatusBadge status={filing.status} />
      {explanation && (
        <p
          className="truncate text-muted-foreground text-xs"
          title={explanation}
        >
          {explanation}
        </p>
      )}
    </div>
  )
}

export const blockedDraftExplanation = (filing: Filing): string | null => {
  if (filing.status !== BANKRUPTCY_STATUSES.draft) return null
  if (filing.numberOfPages === 0) return null

  if (filing.atPageLimit) {
    return `At its ${filing.pageLimit}-page limit`
  }

  return null
}
